import { DimensionEcranForm } from "@/components/common/ScreenDimensionForm";

export default function ProfilePatient() {
  return (
    <div className="w-full flex flex-col justify-center h-full items-center">
      {/* <ProfileCard /> */}
      <DimensionEcranForm portal='patient'/>

    </div>
  );
}
